<template>
  <div class="card mb-3">
        <div class="card-header">
            <strong>{{ $t('timetable-events') }}</strong>
        </div>
        <div class="card-body">
            <div v-if="(ttevents && ttevents.length > 0) || selectedEvents.length > 0">
                <GenericSelector
                    :value="selectedEvents"
                    :options="filteredTtevents"
                    :showOptions="canEdit && showOptions"
                    :canEdit="canEdit"
                    selectorStyle="list"
                    compareKey="id"
                    displayKey="title"
                    :disableNoneSelectedAlert="true"
                    @input="onSelectionChange"
                >
                    <template #unselectedHeader>
                        <div v-if="showOptions" class="d-flex flex-column flex-md-row align-items-md-end" style="gap: 1rem">
                            <SearchBar class="flex-grow-1 mb-3" v-model="search" :debounce="false" />
                            <DateInput v-model="dateFrom" :label="$t('from')" />
                            <DateInput v-model="dateTo" :label="$t('to')" />
                        </div>
                    </template>
                    <template #selected="{ option }">
                        <b-icon v-if="canEdit && showOptions" icon="dash-circle-fill" class="float-right ml-2 text-danger" />
                        <strong>{{ option.title }}</strong>
                        <div class="small text-muted">
                            <template v-if="option.ttsessiontype">{{ option.ttsessiontype.name }}</template>
                            <template v-if="option.ttroom"> &middot; {{ option.ttroom.name }}</template>
                        </div>
                        <div class="small text-muted" v-if="option.date">
                            {{ $datetime.timestampToDate(option.date) }}
                            {{ $datetime.timestampToTime(option.from, false) }}
                            &ndash;
                            {{ $datetime.timestampToTime(option.to, false) }}
                        </div>
                    </template>
                </GenericSelector>
                <button
                    v-if="canEdit"
                    class="btn btn-sm btn-outline-secondary mt-2 float-right"
                    @click="showOptions = !showOptions"
                >
                    {{ showOptions ? $t('hide-events') : $t('add-events') }}
                </button>
            </div>
            <div v-if="ttevents.length == 0 && !events.length">
                <p>{{$t('no-events-current-time-window')}}</p>
            </div>
        </div>
    </div>
</template>
<script>
import GenericSelector from '../Inputs/GenericSelector.vue';
import SearchBar from '../Table/SearchBar.vue';
import DateInput from '../Inputs/DateInput.vue';

export default {
    components: { GenericSelector, SearchBar, DateInput },
    props:{
        events: {
            type: Array,
            default: () => []
        },
        ttevents: {
            type: Array,
            default: () => []
        },
        canEdit: {
            type: Boolean,
            default: true
        },
        multipleSelect: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            selectedEvents: [],
            showOptions: false,
            search: '',
            dateFrom: '',
            dateTo: '',
        }
    },
    computed: {
        filteredTtevents() {
            return this.ttevents.filter(e => {
                if (this.search) {
                    const q = this.search.toLowerCase();
                    if (!e.title || !e.title.toLowerCase().includes(q)) return false;
                }
                if (e.date) {
                    const d = new Date(e.date * 1000);
                    const y = d.getFullYear();
                    const m = String(d.getMonth() + 1).padStart(2, '0');
                    const day = String(d.getDate()).padStart(2, '0');
                    const dateStr = `${y}-${m}-${day}`;
                    if (this.dateFrom && dateStr < this.dateFrom) return false;
                    if (this.dateTo && dateStr > this.dateTo) return false;
                }
                return true;
            });
        }
    },
    methods: {
        onSelectionChange(events) {
            if (!this.multipleSelect && events.length > 1) events.shift();
            this.selectedEvents = events;
            if (!this.multipleSelect && events.length === 1) this.showOptions = false;
            this.$emit('ttevent_ids', events.map(e => e.id));
        },
    },
    watch: {
        events: {
            immediate: true,
            handler(newVal) {
                if (newVal && newVal.length) {
                    this.selectedEvents = newVal;
                    this.$emit('ttevent_ids', newVal.map(e => e.id));
                }
            }
        },
        ttevents: {
            immediate: true,
            handler(newVal) {
                if (!this.events.length && newVal.length === 1) {
                    this.selectedEvents = [newVal[0]];
                    this.$emit('ttevent_ids', [newVal[0].id]);
                }
            }
        }
    }
}
</script>

